import Swal from 'sweetalert2';

// Customise default styling (optional)
const defaultOptions = {
  confirmButtonColor: '#6366f1',    // primary-500
  cancelButtonColor: '#6b7280',     // gray-500
  background: '#ffffff',
  backdrop: 'rgba(0,0,0,0.4)',
  timerProgressBar: true,
};

/**
 * Show a confirmation dialog
 * @param {string} title - Dialog title
 * @param {string} text - Main message
 * @param {string} confirmText - Button text (default: 'Yes, confirm!')
 * @param {string} cancelText - Button text (default: 'Cancel')
 * @param {string} icon - 'question' | 'warning' | 'info' | 'error' | 'success' (default: 'question')
 * @returns {Promise<boolean>} - Resolves to true if confirmed, false otherwise
 */
export const showConfirm = async ({
  title = 'Are you sure?',
  text = 'This action cannot be undone.',
  confirmText = 'Yes, confirm!',
  cancelText = 'Cancel',
  icon = 'question',
} = {}) => {
  const result = await Swal.fire({
    ...defaultOptions,
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
  });
  return result.isConfirmed;
};

/**
 * Show a warning dialog (no cancel)
 */
export const showWarning = async ({
  title = 'Warning',
  text = 'Please review the information.',
  confirmText = 'OK',
  icon = 'warning',
} = {}) => {
  await Swal.fire({
    ...defaultOptions,
    title,
    text,
    icon,
    showCancelButton: false,
    confirmButtonText: confirmText,
  });
};

/**
 * Show an error dialog
 */
export const showError = async ({
  title = 'Error',
  text = 'Something went wrong.',
  confirmText = 'Got it',
  icon = 'error',
} = {}) => {
  await Swal.fire({
    ...defaultOptions,
    title,
    text,
    icon,
    showCancelButton: false,
    confirmButtonText: confirmText,
  });
};

/**
 * Show a success dialog
 */
export const showSuccess = async ({
  title = 'Success!',
  text = 'Operation completed successfully.',
  confirmText = 'Great!',
  icon = 'success',
  timer = 2000,
} = {}) => {
  await Swal.fire({
    ...defaultOptions,
    title,
    text,
    icon,
    timer,
    showConfirmButton: false,
    showCancelButton: false,
    timerProgressBar: true,
    willClose: () => {},
  });
};

/**
 * Show an info dialog
 */
export const showInfo = async ({
  title = 'Info',
  text = 'Just letting you know.',
  confirmText = 'OK',
  icon = 'info',
} = {}) => {
  await Swal.fire({
    ...defaultOptions,
    title,
    text,
    icon,
    showCancelButton: false,
    confirmButtonText: confirmText,
  });
};

export default {
  showConfirm,
  showWarning,
  showError,
  showSuccess,
  showInfo,
};